import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class CustomIconService {
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);

  init() {
    this.registerIcon('csv', 'assets/icons/csv.svg');
    this.registerIcon('doc', 'assets/icons/doc.svg');
    this.registerIcon('jpeg', 'assets/icons/jpeg.svg');
    this.registerIcon('pdf', 'assets/icons/pdf.svg');
    this.registerIcon('txt', 'assets/icons/txt.svg');
    this.registerIcon('xlsx', 'assets/icons/xlsx.svg');
    this.registerIcon('zip', 'assets/icons/zip.svg');
  }

  private registerIcon(name: string, path: string): void {
    this.matIconRegistry.addSvgIcon(name, this.domSanitizer.bypassSecurityTrustResourceUrl(path));
  }
}
